(() => {
  if (customElements.get('ns-localization-form')) return;

  const preferredLanguages = {
    AD: 'es', AL: 'en', AM: 'en', AT: 'de', AX: 'sv', AZ: 'en', BA: 'en', BE: 'nl', BG: 'bg', BV: 'nb', BY: 'en',
    CH: 'de', CY: 'el', CZ: 'cs', DE: 'de', DK: 'da', EE: 'en', ES: 'es', FI: 'fi',
    FO: 'da', FR: 'fr', GB: 'en', GE: 'en', GG: 'en', GI: 'en', GL: 'da', GP: 'fr', GR: 'el', HR: 'hr', HU: 'hu',
    IE: 'en', IM: 'en', IS: 'en', IT: 'it', JE: 'en', KZ: 'en', LI: 'de', LT: 'en', LU: 'fr',
    LV: 'en', MC: 'fr', MD: 'ro', ME: 'en', MK: 'en', MT: 'en', NL: 'nl', NO: 'nb',
    PL: 'pl', PT: 'pt-PT', RE: 'fr', RO: 'ro', RS: 'en', RU: 'en', SE: 'sv', SI: 'sl', SJ: 'nb',
    SK: 'sk', SM: 'it', TR: 'en', UA: 'en', VA: 'it', XK: 'en', YT: 'fr'
  };

  customElements.define('ns-localization-form', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.form = this.querySelector('form');
      this.country = this.querySelector('[data-localization-country]');
      this.language = this.querySelector('[data-localization-language]');
      this.disclosure = this.closest('details');
      if (!this.form || !this.country || !this.language) return;
      this.localizeCountryNames();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.country.addEventListener('change', () => {
        this.synchronizeLanguage();
        this.submitSelection();
      }, options);
      this.language.addEventListener('change', () => this.submitSelection(), options);
      this.form.addEventListener('submit', () => {
        this.form.setAttribute('aria-busy', 'true');
        const submitButton = this.form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;
      }, options);
      this.disclosure?.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.disclosure.open = false;
        this.disclosure.querySelector('summary')?.focus();
      }, options);
      document.addEventListener('click', (event) => {
        if (this.disclosure?.open && !this.disclosure.contains(event.target)) this.disclosure.open = false;
      }, options);
      window.addEventListener('pageshow', () => {
        this.form.removeAttribute('aria-busy');
        const submitButton = this.form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = false;
      }, options);
    }

    localizeCountryNames() {
      if (typeof Intl.DisplayNames !== 'function') return;
      try {
        const names = new Intl.DisplayNames([document.documentElement.lang || 'de'], { type: 'region' });
        for (const option of this.country.options) {
          const currency = option.textContent.match(/\s\(([^()]*)\)\s*$/)?.[1];
          const name = names.of(option.value);
          if (name && currency) option.textContent = `${name} (${currency})`;
        }
      } catch {}
    }

    synchronizeLanguage() {
      const currentLanguage = this.language.value;
      const template = this.querySelector(`[data-country-languages="${this.country.value}"]`);
      if (!template || !template.content.querySelector('option')) return;
      this.language.replaceChildren(template.content.cloneNode(true));
      const languages = Array.from(this.language.options, (option) => option.value);
      const preferred = preferredLanguages[this.country.value] || 'en';
      const equivalent = languages.find((locale) => locale.toLowerCase() === preferred.toLowerCase())
        || languages.find((locale) => locale.split('-')[0] === preferred.split('-')[0]);
      this.language.value = equivalent
        || languages.find((locale) => locale === 'en' || locale.startsWith('en-'))
        || languages.find((locale) => locale === currentLanguage)
        || languages[0];
    }

    submitSelection() {
      if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
      else this.form.submit();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
